package co.maytes.standupbot.dashboard.components.layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import co.maytes.standupbot.dashboard.features.auth.AuthPhase
import co.maytes.standupbot.dashboard.features.onboarding.OnboardingStep
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import com.varabyte.kobweb.core.rememberPageContext
import kotlinx.coroutines.delay

@Composable
fun AuthGuard(content: @Composable () -> Unit) {
    val auth = rememberAuthStore()
    val ctx = rememberPageContext()

    LaunchedEffect(auth.phase) {
        when (val current = auth.phase) {
            AuthPhase.Unauthenticated -> {
                delay(MIN_REDIRECT_DEBOUNCE_MS)
                if (auth.phase == AuthPhase.Unauthenticated) {
                    val returnTo = ctx.route.path
                    ctx.router.navigateTo("/?returnTo=$returnTo")
                }
            }
            is AuthPhase.Authenticated -> {
                val path = ctx.route.path
                val isRoot = path == "/app" || path == "/app/"
                if (auth.requiresOnboarding() && isRoot) {
                    val ws = auth.currentUser?.workspace
                    ctx.router.navigateTo(
                        OnboardingStep.resumePath(
                            slackConnected = ws?.slackConnected == true,
                            linearConnected = ws?.linearConnected == true,
                        ),
                    )
                }
                @Suppress("UNUSED_VARIABLE") val principal = current
            }
            AuthPhase.Loading -> Unit
        }
    }

    when (auth.phase) {
        AuthPhase.Loading, AuthPhase.Unauthenticated ->
            co.maytes.standupbot.dashboard.components.feedback.BrandLoader()
        is AuthPhase.Authenticated -> content()
    }
}

private const val MIN_REDIRECT_DEBOUNCE_MS = 200L
